/** Expenses, the cashbook and money movements (docs/specs/accounting.md). */
export const accounting = {
    expenses: {
        title: "Expenses",
        description: "Money spent from your accounts — rent, bills, salaries, supplies. Each one comes out of an account.",
        record: "Record expense",
        categories: "Categories",
        empty: "No expenses in this period.",
        emptyBody: "Record rent, electricity, salaries and other costs to see them in profit and the cashbook.",
        voided: "Voided",
        voidOf: "Void",
        void: "Void",
        voidReason: "Why is this expense being voided?",
        voidDone: "Expense voided; the money is back in the account.",
        saved: "Expense {{number}} recorded.",
        headOffice: "Head office",
        receipt: "Receipt",
        viewReceipt: "View receipt",
        columns: {
            number: "No.",
            date: "Date",
            category: "Category",
            location: "Branch",
            account: "Paid from",
            description: "Description",
            amount: "Amount",
        },
        filters: {
            from: "From",
            to: "To",
            location: "Branch",
            category: "Category",
            any: "Any",
        },
        form: {
            title: "Record an expense",
            category: "Category",
            location: "Branch",
            account: "Paid from",
            amount: "Amount",
            date: "Date",
            description: "Description",
            receipt: "Receipt photo (optional)",
            uploading: "Uploading…",
            save: "Record expense",
            noCategories: "Add a category first.",
        },
        categoriesSheet: {
            title: "Expense categories",
            name: "New category",
            add: "Add",
            archive: "Archive",
            restore: "Restore",
            archived: "Archived",
            empty: "No categories yet. Add Rent, Electricity, Salaries…",
            saved: "Category saved.",
        },
    },
    cashbook: {
        title: "Cashbook",
        description: "Every taka in and out of a branch's cash drawers and cash boxes, with the balance at each day's end.",
        location: "Branch",
        from: "From",
        to: "To",
        pickLocation: "Choose a branch to see its cashbook.",
        noAccounts: "This branch has no cash drawer or cash box yet.",
        opening: "Opening balance",
        in: "Money in",
        out: "Money out",
        closing: "Closing balance",
        days: "Day by day",
        entries: "Entries",
        truncated: "Only the first {{count}} entries are listed; day totals include everything.",
        empty: "No money moved in this period.",
        columns: {
            date: "Date",
            time: "Time",
            kind: "What",
            account: "Account",
            note: "Details",
            in: "In",
            out: "Out",
            balance: "Balance",
            opening: "Opening",
            closing: "Closing",
        },
    },
    kinds: {
        sale_receipt: "Sale payment",
        refund: "Refund",
        other_in: "Money in",
        other_out: "Money out",
        transfer_in: "Transfer in",
        transfer_out: "Transfer out",
        cod_payout: "Courier payout",
        courier_charge: "Courier charges",
        expense: "Expense",
        supplier_payment: "Supplier payment",
        customer_payment: "Customer dues paid",
        cash_in: "Cash in",
        cash_out: "Cash out",
        shift_variance: "Shift over / short",
    },
};
//# sourceMappingURL=accounting.js.map